import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
axios.defaults.baseURL = API_BASE_URL;

// 업로드 이미지 URL을 절대 경로로 변환
export const getImageUrl = (url) => {
  if (!url) return 'https://via.placeholder.com/300';
  // 이미 절대 URL이면 그대로 반환
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // /uploads/로 시작하면 백엔드 서버 주소 붙이기
  if (url.startsWith('/uploads/')) {
    // 프로덕션(Vercel)에서는 /api 프록시 사용, 로컬에서는 직접 백엔드 접근
    const isProduction = process.env.NODE_ENV === 'production';
    if (isProduction) {
      // Vercel에서는 /api/uploads/... 로 프록시
      return `/api${url}`;
    } else {
      // 로컬 개발환경에서는 직접 백엔드 서버 사용
      return `http://13.124.213.199:5000${url}`;
    }
  }
  return url;
};

// Products
export const getProducts = (params) => axios.get(`/products`, { params });
export const getProduct = (id) => axios.get(`/products/${id}`);
export const createProduct = (data) => axios.post(`/products`, data);
export const updateProduct = (id, data) => axios.put(`/products/${id}`, data);
export const deleteProduct = (id) => axios.delete(`/products/${id}`);

// Categories
export const getCategories = (params) => axios.get(`/categories`, { params });
export const createCategory = (data) => axios.post(`/categories`, data);
export const updateCategory = (id, data) =>
	axios.put(`/categories/${id}`, data);
export const deleteCategory = (id) => axios.delete(`/categories/${id}`);

// Orders
export const getOrders = (params) => axios.get(`/orders`, { params });
export const getOrder = (id) => axios.get(`/orders/${id}`);
export const createOrder = (data) => axios.post(`/orders`, data);
export const createGuestOrder = (data) => axios.post(`/orders/guest/create`, data);
export const getGuestOrder = (data) => axios.post(`/orders/guest`, data);
export const updateOrderStatus = (id, data) =>
	axios.patch(`/orders/${id}/status`, data);

// Admin - Users
export const getUsers = (params) => axios.get(`/admin/users`, { params });
export const getUser = (id) => axios.get(`/admin/users/${id}`);
export const updateUser = (id, data) => axios.put(`/admin/users/${id}`, data);
export const updateUserPoints = (id, data) => axios.post(`/admin/users/${id}/points`, data);

// Admin - Featured Products (추천/히트/인기)
export const getFeaturedProducts = (type) => axios.get(`/admin/featured/${type}`);
export const searchProductsForFeatured = (params) => axios.get(`/admin/featured-search`, { params });
export const addFeaturedProduct = (type, productId) => axios.post(`/admin/featured/${type}/${productId}`);
export const removeFeaturedProduct = (type, productId) => axios.delete(`/admin/featured/${type}/${productId}`);
export const updateFeaturedOrder = (type, productIds) => axios.put(`/admin/featured/${type}/order`, { productIds });

// Weekly Best (대분류별)
export const getWeeklyBestProducts = (categorySlug, limit = 10) => 
  axios.get(`/products/weekly-best/${categorySlug}`, { params: { limit } });

// Notices (공지사항)
export const getNotices = (params) => axios.get(`/notices`, { params });
export const getNotice = (id) => axios.get(`/notices/${id}`);
export const createNotice = (data) => axios.post(`/notices`, data);
export const updateNotice = (id, data) => axios.put(`/notices/${id}`, data);
export const deleteNotice = (id) => axios.delete(`/notices/${id}`);

// Reviews (구매평)
export const getProductReviews = (productId, params) => 
  axios.get(`/reviews/product/${productId}`, { params });
export const createReview = (productId, data) => 
  axios.post(`/reviews/product/${productId}`, data);
export const updateReview = (id, data) => axios.put(`/reviews/${id}`, data);
export const deleteReview = (id) => axios.delete(`/reviews/${id}`);

// Crawler (크롤링)
export const startCrawl = (data) => axios.post(`/admin/crawl/start`, data);
export const stopCrawl = () => axios.post(`/admin/crawl/stop`);
export const getCrawlStatus = () => axios.get(`/admin/crawl/status`);
export const clearCrawlLogs = () => axios.post(`/admin/crawl/clear-logs`);

// Upload (파일 업로드)
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('image', file);
  return axios.post(`/upload/image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const uploadImages = (files) => {
  const formData = new FormData();
  files.forEach(file => formData.append('images', file));
  return axios.post(`/upload/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Admin - Settings (적립금 설정)
export const getAdminSettings = () => axios.get(`/admin/settings`);
export const updateAdminSettings = (data) => axios.put(`/admin/settings`, data);

// Public Settings (회원가입 적립금 등 - 인증 불필요)
export const getPublicSettings = () => axios.get(`/settings/public`);

// User Points (사용자 적립금 조회)
export const getUserPoints = () => axios.get(`/auth/me`);

// User Profile (마이페이지)
export const getUserProfile = () => axios.get(`/auth/profile`);
export const updateUserProfile = (data) => axios.put(`/auth/profile`, data);
export const changePassword = (data) => axios.put(`/auth/password`, data);

// Banners (배너)
export const getBanners = (type) => axios.get(`/banners`, { params: { type } });
